import { getDesks } from '@/rest/desks'
import getLocalizedName from '@/utils/getLocalizedName.js'

export default {
  state: () => ({
    desks: [],
    desksMap: {}
  }),
  getters: {
    desks: (state) => {
      return state.desks
    },
    deskNameById: state => id => {
      return getLocalizedName(state.desksMap[id])
    },
    isDesksFilterVisible: state => {
      return state.desks.length > 0
    }
  },
  mutations: {
    setDesks (state, payload) {
      state.desks = payload
      state.desksMap = payload.reduce((acc, item) => {
        acc[item.id] = item.displayName
        return acc
      }, {})
    }
  },
  actions: {
    async getListOfDesks ({ commit }) {
      const list = await getDesks()

      if (list.length) {
        commit('setDesks', list)
      }
    },
    initialize ({ rootGetters, dispatch }) {
      if (!rootGetters.isAuthorized) {
        return
      }

      dispatch('getListOfDesks')
      import.meta.env.DEV && console.log('initialized store – desks')
    }
  }
}
